import React from 'react';
import Logo from '../assets/logo.png'
import conta from '../assets/conta.svg'
import { useSelector,useDispatch } from 'react-redux'
import {actions} from '../store/reducers/userReducer'

export default function NavUser(props) {
    const { path, history } = props
    const state = useSelector(state => state.userReducer);
    const dispatch = useDispatch();
    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-edited-dark">

            <a className="navbar-brand" href="/home">
                <img src={Logo} width="40" height="40" alt="Logo" />
            </a>

            <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a className={path === '/home' ? "nav-link active": "nav-link"} href="/home">Início</a>
                    </li>
                    <li className="nav-item">
                        <a className={path === '/mycourses' ? "nav-link active": "nav-link"} href="/home">Meus Cursos</a>
                    </li>
                </ul>
            </div>

            <div className='d-flex'>

            <button className="btn btn-outline-light mt-3 mb-3 mr-4" onClick={()=>(dispatch(actions.handleSignOut(history)))}>Sair</button>
            
            <div className='d-flex flex-column text-center'>
                <a className="navbar-brand socialLogos m-0 p-0" href="/home">
                    <img src={conta} width="40" height="40" alt="Logo" />
                </a>
                <span className='text-light'>{state.username}</span>
            </div>

            <button className="navbar-toggler ml-3" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          </div>
        </nav>
    );
}
